/*jslint node: true*/

module.exports = require("./dependentRequired.js");



//////////////////
// WEBPACK FOOTER
// ./app/ko-behaviours-dependentrequired/index.js
// module id = 496
// module chunks = 49